<template>
	<div class="EvaluateDetails">
		<div class="EvaluateDetails_container">
			<div class="EvaluateDetails_input" v-for="(item,index) in scoregradelist">
				<div class="EvaluateDetails_input_left">{{item.scorename}}</div>
				<div class="EvaluateDetails_input_right">
					<van-rate readonly :value="item.userscorevalue" :count="item.scorevalue" color="#ee0a24" void-color="#eee" size="25px" />
				</div>
			</div>
		</div>
		<div class="release_describe">
			<div class="release_type_top">评价</div>
			<div class="release_type_bottom">
				<div class="file_container">
					<textarea disabled @input="file_change" v-model="describe" class="file_text" name="file_text" rows="" maxlength="500" cols="" placeholder="请输入详细描述"></textarea>
				</div>
				<div class="file_num"><span>{{describe.length}}</span>/500</div>
			</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'EvaluateDetails',
		data() {
			return {
				title: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				baseUrl: "",
				access_token: "",
				success: false,
				success_img: false,
				success_text: "",
				file_num: 0,
				describe: "",
				scoregradelist: []
			}
		},
		methods: {
			determine() {
				var that = this;
				if(that.success_text == "评价完成") {
					that.describe = '';
					that.file_num = 0;
					that.$router.back(-1)
				} else {
					that.success = false;
				}
			},
			file_change() {
				var that = this;
				that.file_num = that.describe.length;
				if(that.describe.length >= 500) {
					that.file_num = 500;
					that.describe = that.describe;
				}
			},
			Submission() {
				var that = this;
				if(that.describe == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入详细评价'
				} else {
					var scoreData = [];
					that.gradelist.forEach(item => {
						if(item.value == undefined) {
							item.value = 0;
						}
						scoreData.push({
							'scoreid': item.scoreid,
							'scorevalue': item.value
						})
					})
					console.log(scoreData)
					wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "POST",
						url: that.baseUrl + "?ugi=evaluation&action=explanscore",
						dataType: "json",
						async: true,
						data: {
							ticketuserid: sessionStorage.getItem('ticketuserid'),
							taskid: sessionStorage.getItem('explain_taskid'),
							suggest: that.describe,
							scoreData: JSON.stringify(scoreData)
						},
						success: function(data) {
							wclient.view.hideLoading();
							if(data.code == 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '评价完成'
							}else{
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg
							}
						}
					});
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/explanation/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/explanation/ajax";
			} else {
				var baseUrl = "http://operation.xiangshan1949.cn/explanation/ajax";
			}
			that.baseUrl = baseUrl;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}
			}
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "POST",
				url: that.baseUrl + "?ugi=evaluation&action=checkExplanScore",
				dataType: "json",
				async: true,
				data: {
					ticketuserid: sessionStorage.getItem('ticketuserid'),
					taskid: sessionStorage.getItem('explain_taskid')
				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						that.scoregradelist = data.scoregradelist;
						that.describe=data.suggest;
					} else {
						that.success = true;
						that.success_img = false;
						that.success_text = data.errmsg
					}
				}
			});
		}
	}
</script>

<style scoped>
	.EvaluateDetails {
		width: 100%;
		margin: 0 auto;
		height: 100vh;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
	
	.EvaluateDetails_container {
		width: 90%;
		margin: 0 auto;
	}
	
	.EvaluateDetails_input_right {
		display: flex;
		align-items: center;
	}
	
	.release_btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	
	.release_btn_cli {
		width: 70%;
		margin: 0 auto;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 40px;
		text-align: center;
		color: white;
		border-radius: 20px;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 23%;
		margin-left: 39%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 80%;
		color: black;
		font-size: 17px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.EvaluateDetails_input {
		width: 100%;
		border-bottom: 1px solid #DBDBDB;
		display: flex;
		justify-content: space-between;
		line-height: 60px;
		font-size: 16px;
	}
	
	input {
		border: none;
		outline: none;
		text-align: right;
		font-size: 16px;
	}
	
	.release_describe {
		width: 90%;
		padding: 0 5%;
		margin-bottom: 100px;
	}
	
	.release_type_top {
		width: 100%;
		padding: 15px 0;
		font-size: 15px;
	}
	
	.release_type_bottom {
		width: 100%;
		border: 1px solid rgba(222, 222, 222, 1);
	}
	
	.file_container {
		width: 100%;
		position: relative;
	}
	
	.file_text {
		display: block;
		width: 90%;
		height: 160px;
		background: white;
		outline: none;
		padding: 20px 5% 0;
		font-size: 14px;
		overflow: hidden;
		border-radius: 4px;
		resize: none;
		line-height: 20px;
		border: none;
		overflow-y: scroll;
	}
	
	.file_num {
		color: rgba(180, 180, 180, 1);
		width: 90%;
		text-align: right;
		line-height: 45px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/evaluateDetails.vue